import React, { useState, useEffect } from 'react'
import Icon from 'components/Icon/Icon'
import styled from 'particles/themes/styled'
import ExtendedNavbar from './ExtendedNavbar'
import { useWindowSize } from 'hooks'
interface SmallScreenNavBarProp {
    className?: string
}

const SmallScreenNavBar: React.FC<SmallScreenNavBarProp> = ({ className }) => {
    const [showNavBar, setShowNavBar] = useState(false)
    const windowSize = useWindowSize()

    useEffect(() => {
        if (windowSize && windowSize > 768) {
            setShowNavBar(false)
        }
    }, [windowSize])

    return (
        <>
            <div className={className} id="small-navbar">
                <Icon.FullLogoIcon />
                <Icon.BurgerMenuIcon className="burger-menu" onClick={() => setShowNavBar(true)} />
            </div>
            <ExtendedNavbar toggleClose={setShowNavBar} isExtend={showNavBar} />
        </>
    )
}
export default styled(SmallScreenNavBar)`
    max-width: 1920px;
    display: none;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 2rem;
    justify-content: space-between;
    .burger-menu {
        cursor: pointer;
    }
    @media screen and (max-width: 768px) {
        display: flex;
    }
    @media screen and (max-width: 375px) {
        padding: 2rem 1rem;
    }
`
